import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { HomeBannersDto } from '@proxy/home-banners';

@Injectable({
  providedIn: 'root',
})
export class CustomHomeBannersSettingsService {
  apiName = 'Default';

  constructor(private restService: RestService) {}

  getHomeBannersPublic = () =>
    this.restService.request<any, HomeBannersDto>(
      {
        method: 'GET',
        url: '/api/app/home-banners-settings/home-banners-public',
      },
      { apiName: this.apiName, skipHandleError: true }
    );

  uploadBannerImage = (file: File, bannerIndex: number) => {
    const formData = new FormData();
    formData.append('File', file, file.name);
    formData.append('BannerIndex', bannerIndex.toString());

    return this.restService.request<any, string>(
      {
        method: 'POST',
        responseType: 'text',
        url: '/api/app/home-banners-settings/upload-banner-image',
        body: formData,
      },
      { apiName: this.apiName }
    );
  };
}
